import styled from '@emotion/styled'

import { Paper } from './Paper'
import { theme } from '../constants'
import { Color } from '../constants/color'

const BORDER_WIDTH = theme.border.radius.normal

export const StatusPaper = styled(Paper)<{
  statusColor: Color
}>`
  border-left: ${BORDER_WIDTH}px solid ${({ statusColor }) => statusColor};
  position: relative;

  ::before {
    content: '';
    position: absolute;
    top: ${-theme.border.width.thin}px;
    left: -${BORDER_WIDTH}px;
    bottom: ${-theme.border.width.thin}px;
    border-bottom-left-radius: ${theme.border.radius.normal}px;
    border-top-left-radius: ${theme.border.radius.normal}px;
    background-color: ${({ statusColor }) => statusColor};
    width: ${BORDER_WIDTH}px;
  }
`
